import type { MediaType } from "@/types/movie";

export const typeLabelMap: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const typePathMap: Record<MediaType, string> = {
  movie: "movie",
  tv: "tv",
  variety: "variety",
};

export const pathTypeMap: Record<string, MediaType> = {
  movie: "movie",
  tv: "tv",
  variety: "variety",
};

export function typeLabel(type: string): string {
  return typeLabelMap[type as MediaType] ?? type;
}

export function isMediaType(value: string): value is MediaType {
  return value === "movie" || value === "tv" || value === "variety";
}

export function formatPopularity(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}